import type { OrderDetail } from '../services/api';

/** CAR_TYPES display names (garages lookup). */
const VEHICLE_TYPE_NAMES: Record<string, string> = {
  SEDAN: 'Sedan',
  SUV: 'SUV',
  HATCHBACK: 'Hatchback',
  COUPE: 'Coupe',
  TRUCK_PICKUP: 'Truck/Pickup',
  VAN_MINIVAN: 'Van/Minivan',
  CONVERTIBLE: 'Convertible',
  SPORTS_CAR: 'Sports Car',
  LUXURY: 'Luxury',
  ELECTRIC_VEHICLE: 'Electric Vehicle',
};

/**
 * #1435 — "Booked size may be too small for this vehicle (SUV booked as Hatchback / Sedan)" when the
 * order's booked size is smaller than the saved vehicle; null otherwise.
 */
export function sizeMismatchText(
  order: Pick<OrderDetail, 'sizeMismatch' | 'vehicleType' | 'sizeBookedAs'>,
): string | null {
  if (order.sizeMismatch !== 'UNDER') return null;
  const type = order.vehicleType ? VEHICLE_TYPE_NAMES[order.vehicleType] ?? order.vehicleType : null;
  const bookedAs = order.sizeBookedAs?.trim();
  const detail = type && bookedAs ? ` (${type} booked as ${bookedAs})` : '';
  return `Booked size may be too small for this vehicle${detail}`;
}
